"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const trans_1 = require("@common/tsutils/trans");
const unique_1 = require("@common/tsutils/unique");
const common_1 = require("@becrop/components/Toolkit/Heatmap2/models/common");
class Filter {
    constructor() {
        // The type of filter
        this.type = 'boolean';
        // The data origin: core, csv or ranks
        this.origin = 'core';
        // The unique ID - lang independent
        this.id = '';
        // The name
        this.name = '';
        // The path to retrieve the value in the sample object
        this.sample_path = '';
        // Function to get the labels of the options
        this.option_label_fn = common_1.identify_fn;
        this.enabled = true;
    }
    /**
     * This methods takes the possible values of the samples
     * for the particular filter
     * and sets the enabled flag if there are valid values
     * For list, also sets the list of options.
     * @param library
     */
    initFilter(library) {
        const options = library.map(s => {
            return s.retrieveValueForFilterOrGroup(this);
        }).filter(x => {
            return x !== undefined && x !== null;
        }).map(x => {
            return (x + '').trim();
        }).filter(unique_1.uniqueFilter);
        if (this.type === 'list') {
            this.list_options = options;
        }
        // This will make the filter unselectable
        if (!options.length)
            this.enabled = false;
    }
    static newFilter(type, id, path, name) {
        const f = new Filter();
        f.type = type;
        f.id = id;
        f.name = name || (0, trans_1.trans)('heatmap.metadata_items.' + id);
        f.sample_path = path;
        f.origin = name === null ? 'core' : 'csv';
        return f;
    }
    static newBoolean(id, path, name = null) {
        return Filter.newFilter('boolean', id, path, name);
    }
    static newList(id, path, labels = common_1.identify_fn, name = null) {
        const f = Filter.newFilter('list', id, path, name);
        f.list_options = [];
        if (labels)
            f.option_label_fn = labels;
        return f;
    }
    static newNumber(id, path, name = null) {
        return Filter.newFilter('number', id, path, name);
    }
    static newDate(id, path, name = null) {
        return Filter.newFilter('date', id, path, name);
    }
    static newFilterFromMetadata(type, id, name) {
        const f = new Filter();
        f.type = type;
        f.id = id;
        f.name = name;
        f.origin = 'csv';
        return f;
    }
}
exports.default = Filter;
